import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Drawer from '@blade/common/components/task-management/paint.vue';
import { cloneDeep } from 'lodash';
let default_1 = class default_1 extends Vue {
    width;
    height;
    zoneInfo;
    // @Prop({ default: false }) paintState!:boolean
    paintState = false;
    onEndDraw;
    closeDrawer;
    onChangeMapSource(val) {
        console.log(val);
    }
    context2d = null;
    canvasDom = null;
    canvasPolygonsId = '';
    buttons = ['polygon'];
    styleProp = {
        width: 0,
        height: 0,
    };
    options = {
        normal: {
            fillStyle: '#0077FA',
            strokeStyle: '#3295FB',
            lineWidth: 2,
            globalAlpha: 1,
        },
    };
    // event 对象 offset, client 区别：https://blog.csdn.net/lzding/article/details/45437707
    pointsOffset = []; // canvas 上绘图使用 offset
    pointsClient = []; // 转换为 map 坐标系中位置，需要使用 client
    geoType = 'polygon';
    mounted() {
        this.styleProp.width = this.width;
        this.styleProp.height = this.height;
        let that = this;
        this.paintState = true;
        document.oncontextmenu = function (e) {
            // 整个页面的js事件
            that.closeDrawer();
            return false; // 阻止右键弹窗
        };
    }
    drawLine = () => { };
    drawPolygon() {
        if (!this.context2d) {
            return;
        }
        this.clearCanvas();
        // 绘制带文字的 dot
        const radius = 7;
        this.pointsOffset.forEach((point, index) => {
            this.context2d?.beginPath();
            this.context2d?.arc(point.x, point.y, radius, 0, Math.PI * 2);
            console.log('this.pointsOffset', this.pointsOffset);
            this.context2d.fillStyle = 'red';
            this.context2d.fill();
            // draw text: 水平，垂直都居中
            // https://stackoverflow.com/questions/13771310/center-proportional-font-text-in-an-html5-canvas
            // https://www.cnblogs.com/amtf/archive/2012/01/18/2324343.html
            const textFont = '12px serif';
            const textStr = String(index + 1);
            this.context2d.fillStyle = 'white';
            this.context2d.font = textFont;
            this.context2d.textBaseline = 'middle';
            const textWidth = this.context2d.measureText(textStr).width;
            this.context2d.fillText(textStr, point.x - textWidth / 2, point.y);
        });
    }
    onMouseDown(event) {
        // only left button
        if (event.button !== 0) {
            return;
        }
        console.log('onMouseDown', event);
        this.pointsOffset.push({ x: event.offsetX, y: event.offsetY });
        this.pointsClient.push({ x: event.clientX, y: event.clientY });
        switch (this.geoType) {
            case 'polygon':
                this.drawPolygon();
                break;
            case 'line':
                break;
        }
    }
    // closeDrawer() {
    //   this.paintState = false;
    // }
    onMouseMove = (event) => { };
    onMouseUp = (event) => {
        // only left button
        if (event.button !== 0) {
        }
    };
    onClearClick() {
        this.pointsOffset = [];
        this.pointsClient = [];
        this.clearCanvas();
    }
    clearCanvas() {
        const dom = this.$refs.simpleDrawer;
        dom.deleteGraph(this.canvasPolygonsId);
    }
    formatPolygons(val) {
        this.pointsOffset = [];
        this.pointsClient = [];
        const dom = document.querySelector('.zone-view');
        const rectInfor = dom.getBoundingClientRect();
        const offSetLeft = rectInfor.left;
        const offSetTop = rectInfor.top;
        let mapPolygons = [];
        const h = this.styleProp.height;
        const w = this.styleProp.width;
        if (h && w && val) {
            mapPolygons = cloneDeep(val).map((item) => {
                let verticesLocal = [];
                verticesLocal = item.vertices.map((item) => {
                    return {
                        x: Number(item.x) * w + offSetLeft,
                        y: Number(item.y) * h + offSetTop,
                    };
                });
                return {
                    id: item.id,
                    options: item.options,
                    outsideRect: item.outsideRect,
                    status: item.status,
                    type: item.type,
                    vertices: verticesLocal,
                };
            });
        }
        for (let value of mapPolygons) {
            this.canvasPolygonsId = value.id;
            for (let key of value.vertices) {
                this.pointsOffset.push({ x: key.x, y: key.y });
                this.pointsClient.push({ x: key.x, y: key.y });
            }
        }
        this.onEndDraw('polygon', this.pointsClient);
    }
    getMapdrawend(val) {
        this.paintState = false;
        if (val.length === 0) {
            this.paintState = true;
        }
        this.formatPolygons(val);
    }
};
__decorate([
    Prop()
], default_1.prototype, "width", void 0);
__decorate([
    Prop()
], default_1.prototype, "height", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneInfo", void 0);
__decorate([
    Prop()
], default_1.prototype, "onEndDraw", void 0);
__decorate([
    Prop()
], default_1.prototype, "closeDrawer", void 0);
__decorate([
    Watch('paintState', { immediate: true, deep: true })
], default_1.prototype, "onChangeMapSource", null);
default_1 = __decorate([
    Component({
        name: 'GeometryDrawer',
        components: {
            'st-drawer': Drawer,
        },
        i18n: {
            messages: {
                zh: {},
                en: {
                    name: 'Zone Name:',
                },
            },
        },
    })
], default_1);
export default default_1;
